import { integrationSlugs } from '@global/constants'
import { t } from '@lingui/core/macro'
import { IntegrationError } from './integration-error'

function validateBranchRowLimit(datasetRows: any[], submissionErrors: IntegrationError[]): void {
  if (datasetRows.length > 100) {
    const error: IntegrationError = {
      integration: integrationSlugs.BRANCH,
      errorMsg: t`Submissions using the Branch integration cannot exceed 100 rows.`,
    }
    submissionErrors.push(error)
  }
}

export function validateBranchSubmission(
  _: any,
  datasetRows: any[],
  submissionErrors: IntegrationError[],
): void {
  //   currently just checking the # of rows in a branch submission.
  //   other validation function calls will be added within this function.
  validateBranchRowLimit(datasetRows, submissionErrors)
}

// have the potential for cell by cell validation per integration requirements
// ex. branch $deep-path mapping field has to start with ://
